export const PAGES = {
  "auth/Login": () => import("@screens/login/Login"),
  "workspace/WorkspaceLayout": () => import("@screens/workspace/WorkspaceLayout"),
  "workspace/Dashboard": () => import("@screens/dashboard/Dashboard"),
  "workspace/ClassPage": () => import("@screens/classPage/ClassPage"),
  "workspace/Storage": () => import("@screens/storage/Storage"),
  "workspace/Agenda": () => import("@screens/agenda/Agenda"),
  "workspace/Tasks": () => import("@screens/tasks/Tasks"),
  "workspace/Settings": () => import("@screens/settings/Settings"),
} as const;

export type ValidPaths = keyof typeof PAGES;
